
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { LOGOUT_ACTION_TYPE } from '../../common/client/sagas/auth';

const LogoutPage = () => {

    const token = useSelector(state => {
        return (state.auth.data  && state.auth.data.user)
            ? state.auth.data.user.token
            : null;
    });

    const dispatch = useDispatch();

    const logout = (token) => dispatch({
        type: LOGOUT_ACTION_TYPE.DEFAULT, token
    });

    useEffect(() => {
        logout(token);
    });

    if (token) {
        return <div>Odhlašování...</div>
    } else {
        return (
            <div>
                <div>Odhlášení proběhlo v pořádku</div>
                <Link to="/">Domů</Link>
            </div>
        );
    }
}

export default LogoutPage;
